@if (loading()) {
    <p-skeleton class="w-full h-full" height="7,25rem"></p-skeleton>
} @else {
    @if (disabled()) {
        <div class="w-full h-full p-4 bg-neutral-950 rounded-sm flex flex-col items-center">
            <span class="text-2xl text-muted-color text-center m-auto">{{disabledText() | translate}}</span>
        </div>
    } @else {
        <div class="w-full h-full p-4 bg-neutral-950 rounded-sm flex flex-col">
            <h1 class="font-bold">{{title() | translate}}</h1>

            <div class="w-full h-0.5 mt-1 mb-1 bg-neutral-800"></div>

            @for (item of items(); track $index; let isLast = $last) {
                <div class="w-full flex flex-row">
                    <div class="flex flex-col flex-1 min-w-0">
                        <span class="truncate" [title]="item.text">{{item.text}}</span>
                        @if (item.sub) {
                            <span class="text-xs text-muted-color">{{item.sub}}</span>
                        }
                    </div>

                    @if (item.add) {
                        <span [class]="'ml-2 shrink-0 text-muted-color ' + item.addClass">{{item.add}}</span>
                    }
                </div>

                @if (!isLast) {
                    <div class="w-full h-0.5 mt-1 mb-1 bg-neutral-800"></div>
                }
            } @empty {
                <span class="text-muted-color text-2xl p-2 mb-2 text-center m-auto">{{emptyText()}}</span>
            }

            <div class="w-full h-0.5 mt-auto mb-1 bg-neutral-800"></div>

            @if (additionalLinkTitle()) {
                @if (additionalLinkUrl()) {
                    <a class="text-primary flex flex-row rounded-sm p-1 hover:bg-highlight cursor-pointer transition" [routerLink]="additionalLinkUrl()">
                        <span>{{additionalLinkTitle() | translate}}</span>
                        <mat-icon iconClass="ml-auto">arrow_forward</mat-icon>
                    </a>
                } @else {
                    <span class="text-muted-color p-1">{{additionalLinkTitle() | translate}}</span>
                }
            }
        </div>
    }
}